<template>
  <BaseButton
    class="button--fb-new w-full"
    color="white"
    @click="click"
  >
    {{ text }}
  </BaseButton>
</template>
<script>
import { csrfToken } from '@/utils';

import BaseButton from './BaseButton.vue';

export default {
  name: 'FacebookLoginButton',
  emits: ['click', 'success', 'error'],
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      default: 'Login with Facebook',
    },
    apiConfig: {
      type: Object,
      required: true,
    },
    trackingParams: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async click() {
      this.$emit('click');

      try {
        const { isSuccess, ...response } = await App.es6.views.login.facebookAuth.trigger({
          token: csrfToken(),
          url: this.apiConfig.facebookAuth,
          trackingParams: this.trackingParams,
        });
        if (isSuccess) {
          this.$emit('success', response);
        } else {
          this.$emit('error', 'Facebook login: Email permissions are required. Try again or use another login method.');
        }
      } catch (error) {
        this.$emit('error', 'Facebook login: Email permissions are required. Try again or use another login method.');
      }
    },
  },
  mounted() {
    App.es6.views.login.facebookAuth.loadFacebookSDK();
  },
};
</script>
